<template>
  <v-card id="edit-promosi-card">
    <v-card-text>
      <v-form v-model="valid" ref="form" id="edit-promosi" lazy-validation>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <v-text-field label="Nama Promosi" name="title" v-model="user.name">
            </v-text-field>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              class="pr-2"
              ref="statDate"
              lazy
              :close-on-content-click="false"
              v-model="startDateMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              max-width="290px"
              :return-value.sync="startDate"
            >
              <v-text-field
                slot="activator"
                label="Tanggal Mulai"
                v-model="startDate"
                append-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="startDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="startDateMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.statDate.save(startDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm6 lg6>
            <v-menu
              ref="startTime"
              lazy
              :close-on-content-click="false"
              v-model="startTimeMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-24"
              max-width="290px"
              :return-value.sync="startTime"
            >
              <v-text-field
                slot="activator"
                label="Waktu Dimulai"
                v-model="startTime"
                append-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="startTime">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="startTimeMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.startTime.save(startTime)">OK</v-btn>                
              </v-time-picker>
            </v-menu>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="endDate"
              lazy
              class="pr-2"
              :close-on-content-click="false"
              v-model="endDateMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              min-width="290px"
              :return-value.sync="endDate"
            >
              <v-text-field
                slot="activator"
                label="Tanggal Berakhir"
                v-model="endDate"
                append-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="endDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="endDateMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.endDate.save(endDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm6 lg6>
            <v-menu
              ref="endTime"
              lazy
              :close-on-content-click="false"
              v-model="endTimeMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-24"
              max-width="290px"
              :return-value.sync="endTime"
            >
              <v-text-field
                slot="activator"
                label="Waktu Berakhir"
                v-model="endTime"
                append-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="endTime" >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="endTimeMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.endTime.save(endTime)">OK</v-btn>                
              </v-time-picker>
            </v-menu>
          </v-flex>

          <v-flex lg12 sm12>
            <img :src="imageUrl" height="150" v-if="imageUrl"/>
            <v-text-field label="Select Image" @click='pickFile' v-model='imageName' prepend-icon='upload_file'></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="onFilePicked"
            >
          </v-flex>

          <v-flex sm12>
            <h3 class="pa-0">Deskripsi</h3>
          </v-flex>
          <v-flex sm12>
            <quill-editor 
              class="quill"
              :content="editorContent"
              :options="editorOption"
              v-model="user.jobTitle"
            >
            </quill-editor>      
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>        
        <br><br><br><br>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" form="tambahkan-promosi" @click="getPromotion()">Perbaharui Promosi</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { getUserById } from '@/api/user';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  components: {
    quillEditor
  },
  data: () => ({
    title: null,
    valid: true,
    date: null,
    startDateMenu: false,
    startDate: null,
    startTimeMenu: false,
    startTime: null,
    endDateMenu: false,
    endDate: null,
    endTimeMenu: false,
    endTime: null,
    modal: false ,
    imageName: null,
		imageUrl: null,
		promotionImage: null,
    editorContent: null,
    editorOption: {

    }
  }),

  computed: { 
    user () {
      let Origin = {
        name: 'Promosi',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },

  methods: {
    pickFile () {
      this.$refs.image.click ()
    },
		
		onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.promotionImage = files[0] // this is an image file that can be sent to server...
				})
			} else {
				this.imageName = ''
				this.promotionImage = ''
				this.imageUrl = ''
			}
		},

    closeDialog () {
      this.$parent.isActive = false;
    },

    getPromotion (){
      console.log("Test Data Title : ", this.title)
      console.log("Test Data Start Date : ", this.startDate)
      console.log("Test Data Start Time: ", this.startTime)
      console.log("Test Data End Date : ", this.endDate)
      console.log("Test Data End Time : ", this.endTime)
      console.log("Test Data Promotion Image : ", this.promotionImage)
      console.log("Test Data Editor's data : ", this.editorContent)
    }
  }
};
</script>

<style lang="stylus" scoped>
  #edit-promosi-card
    margin: 3% 3%
  
  #edit-promosi
    margin: 2% 2%

  .quill
    height : 360px
</style>
